<template>
  <div class="subscription-info">
    <h2>Your Active Subscription</h2>
    <p><strong>Started:</strong> {{ new Date(subscription.startDate).toLocaleDateString() }}</p>
    <p v-if="subscription.trialEndDate"><strong>Trial Ends:</strong> {{ new Date(subscription.trialEndDate).toLocaleDateString() }}</p>
    <p v-if="subscription.nextPaymentDate"><strong>Next Payment:</strong> {{ new Date(subscription.nextPaymentDate).toLocaleDateString() }}</p>
    <button class="error unsubscribe-btn" @click="$emit('unsubscribe')" style="margin-top: 4rem">Unsubscribe</button>
  </div>
</template>

<script setup>
defineProps({
  subscription: {
    type: Object,
    required: true
  }
})

defineEmits(['unsubscribe'])
</script>

<style scoped>
.subscription-info {
  background: var(--color-background-mute);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 1.5rem;
  margin: 2rem 0;
  text-align: left;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 450px) {
  .subscription-info {
    padding: 1rem;
    margin: 1rem 0;
  }
}

.subscription-info h2 {
  margin-top: 0;
  margin-bottom: 1rem;
  color: var(--color-heading);
}

@media (max-width: 450px) {
  .subscription-info h2 {
    font-size: 1.25rem;
  }
}

.subscription-info p {
  margin: 0.5rem 0;
}

.unsubscribe-btn {
  background: none;
  border: none;
  color: var(--color-error);
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0 1rem;
  display: block;
  margin: 0 auto;
}
</style>